import { useContext, useEffect, useMemo, useRef, useState } from "react";
import './css/index.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faTimes } from "@fortawesome/free-solid-svg-icons";
import { ChatAtendenteContext } from "../../contexts/ChatAtendenteContext";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { OpcoesIniciais } from "./OpcoesIniciais";
import { ChatHistorico } from "./ChatHistorico";
import { ChatConversa } from "./ChatConversa";
import { CriarAtendimentoForm } from "./CriarAtendimentoForm";
import { CentralAjudaService } from "../../services/CentralAjudaService";
import { AtendimentoType } from "../../types/AtendimentoType";
import { AppContext } from "../../contexts/AppContext";
import { Spinner } from "react-bootstrap";

export type statusLoading = {
  loading: boolean,
  error: boolean,
  finished: boolean
}

export default function DommusBoxChat() {
   
    const [loadingAtendimentosAtivos, setLoadingAtendimentosAtivos] = useState(false);
    const {setOpenModalChat, modoVisualizacao, handleModoVisualizacao, setAtendimentoAtivo} = useContext(ChatAtendenteContext);
    const {userData} = useContext(AppContext); 
    const modalRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (modalRef.current && !modalRef.current.contains(event.target) && !event?.target.closest('.dommus-btn-atendimento-chat')) {
          setOpenModalChat(false);
        }
      };
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }, [modalRef]);

    useEffect(()=>{
      setLoadingAtendimentosAtivos(true);
      const filtros = {
        somente_aberto: true
      }
      CentralAjudaService.atendimento.buscarAtendimentosPorSlug('central_ajuda', filtros).then((response)=>{
        setLoadingAtendimentosAtivos(false);
        const atendimentos = response.data;
        setAtendimentoAtivo(atendimentos[0] ?? {} as AtendimentoType);
      }).catch((error)=>{
        setLoadingAtendimentosAtivos(false);
      })
    },[])

    const title = useMemo(()=>{
      switch(modoVisualizacao){
        case 'historico':
          return (
            <span className="title-header">
                Histórico
            </span>
          )
        case 'chat':
          return (
            <span className="title-header">
                Chat
            </span>
          )
        default:
          return (
            <span className="title-header">
            </span>
          )
      }
    },[modoVisualizacao])

    const sections = useMemo(()=>{
      switch(modoVisualizacao){
        case 'historico':
          return <ChatHistorico/> 
        case 'criar_atendimento':
          return <CriarAtendimentoForm/>
        case 'chat':
          return <ChatConversa/>;
        default:
          return <OpcoesIniciais/>
      }
    },[modoVisualizacao])

    return (
        <div className="dommus-box-chat" ref={modalRef}>
          <div className="dommus-box-header-chat">
            <div className="title-section">
              {
                modoVisualizacao !== 'default' && (
                  <FontAwesomeIcon color="#FFF" style={{cursor: 'pointer'}} onClick={() => handleModoVisualizacao('default')} icon={faArrowLeft}/>
                )
              }
              {title}
            </div>
            <span 
              className="btn-close-header"
              onClick={() => {
                setOpenModalChat(false)
              }}
            >
              <FontAwesomeIcon icon={faTimes as IconProp}/>
            </span>

          </div>
          {loadingAtendimentosAtivos ? 
            <div className="info-atendimentos-em-aberto">
              <div className="user-section">
                <div>
                  <span>Olá,</span>
                  <span className="nome">{userData?.nome ?? "---"}</span>
                </div>            
                <div className="informativo-carregando-atendimento">
                  <span>Um momento, estamos procurando atendimentos em aberto!</span>
                  <Spinner
                    as="span"
                    animation="border"
                    role="status"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </div>
           : 
            sections
          }
      </div>
    );
}
